import { ApiClient } from './api-client';
import { UserProfile } from '../types';

export interface RegisterPayload {
  siret: string;
  raison_sociale: string;
  email: string;
  telephone: string;
  password: string;
}

export interface LoginPayload {
  identifier: string;
  password: string;
}

export interface AuthResponseData {
  message: string;
  token?: string;
  requiresValidation?: boolean;
  user: UserProfile;
}

export class AuthApi {
  public static async register(payload: RegisterPayload): Promise<AuthResponseData> {
    const data = await ApiClient.request<AuthResponseData>('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    if (data.token) {
      ApiClient.setToken(data.token);
    }
    return data;
  }

  public static async login(payload: LoginPayload): Promise<AuthResponseData> {
    const data = await ApiClient.request<AuthResponseData>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
    ApiClient.setToken(data.token || null);
    return data;
  }

  public static async getMe(): Promise<UserProfile> {
    return ApiClient.request<UserProfile>('/api/auth/me');
  }

  public static async updateProfile(payload: { email: string; telephone: string }): Promise<AuthResponseData> {
    const data = await ApiClient.request<AuthResponseData>('/api/auth/me', {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
    if (data.token) {
      ApiClient.setToken(data.token);
    }
    return data;
  }

  public static async changePassword(payload: { currentPassword: string; newPassword: string }): Promise<{ success: boolean; message: string }> {
    return ApiClient.request<{ success: boolean; message: string }>('/api/auth/me/password', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  public static logout(): void {
    ApiClient.setToken(null);
  }
}
